import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import LinearProgress from '@material-ui/core/LinearProgress';
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import Close from '@material-ui/icons/Close'
import ErrorOutline from '@material-ui/icons/ErrorOutline'
import withStyles from '@material-ui/core/styles/withStyles';
import firebase from '../../Firebase';
import { connect } from 'react-redux'
import AsyncStorage from '@callstack/async-storage';

const styles = theme => ({
  '@global': {
    '*::-webkit-scrollbar': {
      width: '0.4em'
    },
    '*::-webkit-scrollbar-thumb': {
      backgroundColor: '#f2a811',
      borderRadius: '5px',
    }
  },
  main: {
    width: 'auto',
    display: 'block',
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
      width: 400,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing.unit * 8,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
  },
  avatar: {
    margin: theme.spacing.unit,
    backgroundColor: '#fff',
    width: 170,
    height: 170,
    borderRadius: 0,
  },
  form: {
    width: '100%',
    marginTop: theme.spacing.unit,
  },
  label: {
    '&$cssFocused': {
      color: '#f2a811',
    },
  },
  input: {
    '&:after': {
      borderBottomColor: '#f2a811',
    },
  },
  checkbox: {
    color: '#f2a811',
    '&$checked': {
      color: '#f2a811',
    },
  },
  button: {
    marginTop: theme.spacing.unit * 3,
    color: '#fff',
    backgroundColor: '#f2a811',
    '&:hover': {
      backgroundColor: '#b1730d',
    },
  },
  loadingColorPrimary: {
    backgroundColor: '#f2a811',
  },
  loadingBarColorPrimary: {
    backgroundColor: '#b1730d',
  },
  snackbarError: {
    backgroundColor: theme.palette.error.dark,
  },
  snackbarErrorMessage: {
    display: 'flex',
    alignItems: 'center',
  },
  errorIcon: {
    fontSize: 20,
  },
});

class Login extends React.Component {
  constructor(props){
    super(props)
    this.state={
      loading: false,
      error: false,
      errorMsg: "",
      phone: "",
      password: "",
      remember: false,
    }
  }

  componentWillMount()
  {
    AsyncStorage.getItem("remembered").then(r => {
      if(r)
        this.setState({remember:true, phone:JSON.parse(r).phone, password:JSON.parse(r).password})
    });
  }

  componentWillUnmount(){
  }

  async login(){
    if(this.state.phone != "" && this.state.password != ""){
      this.setState({loading:true});
      let login = false;
      let u;

      firebase
      .auth()
      .signInWithEmailAndPassword(this.state.phone+"@easysuki.com", this.state.password)
      .then((user) => {  

        let userid = user.user.uid
     
        firebase.firestore().collection('users').doc(userid)
          .get()
          .then( snapshot => {
              
             let user = snapshot.data()
             this.props.setUser(userid,user)
            
              if(this.state.remember)
                AsyncStorage.setItem('remembered', JSON.stringify({phone:this.state.phone, password:this.state.password}));
              else
                AsyncStorage.removeItem('remembered');
                
              AsyncStorage.multiSet([['user', JSON.stringify(user)], ['uid', userid]]);
              
              if(user.roles.includes("admin"))
                  this.props.navigation.navigate("Users");
              else if(user.roles.includes("seller"))
                  this.props.navigation.navigate("Inventory");
              else
                  this.setState({loading:false, error:true, errorMsg:" Only user types, admin and seller can login to this system."});

          } )
  
      } )
      .catch(error => this.setState({ error:true, errorMsg: error.message,loading:false }))

    
    } else{
      this.setState({error:true, errorMsg:" All fields must be filled-up."});
    }
  }

  render(){
    const { classes } = this.props;
   
    return (
      <main className={classes.main}>
        <CssBaseline />
        <Paper className={classes.paper}>
          <Avatar src="images/easysuki-logo.png" className={classes.avatar}/>
          <form className={classes.form}>
            <FormControl margin="normal" required fullWidth>
              <InputLabel htmlFor="email" className={classes.label}>Phone</InputLabel>
              <Input id="phone" name="phone" autoComplete="phone" autoFocus className={classes.input} value={this.state.phone}
                onChange={event => {
                  const { value } = event.target;
                  this.setState({ phone: value });
                }}
              />
            </FormControl>
            <FormControl margin="normal" required fullWidth>
              <InputLabel htmlFor="password" className={classes.label}>Password</InputLabel>
              <Input name="password" type="password" id="password" autoComplete="current-password" className={classes.input} value={this.state.password}
                onChange={event => {
                  const { value } = event.target;
                  this.setState({ password: value });
                }}
              />
            </FormControl>
            <FormControlLabel
              control={
                <Checkbox value="remember" color="#f2a811" checked={this.state.remember} className={classes.checkbox}
                  onChange={event => {
                    this.setState({ remember: event.target.checked });
                  }}
                />
              }
              label="Remember me"
            />
            { this.state.loading &&
              <LinearProgress
                classes={{
                  colorPrimary: classes.loadingColorPrimary,
                  barColorPrimary: classes.loadingBarColorPrimary,
                }}
              />
            }
            { this.state.error &&
              <SnackbarContent
                className={classes.snackbarError}
                aria-describedby="client-snackbar"
                message={
                  <span id="client-snackbar" className={classes.snackbarErrorMessage}>
                    <ErrorOutline className={classes.errorIcon} />
                    {this.state.errorMsg}
                  </span>
                }
                action={[
                  <IconButton
                    key="close"
                    aria-label="Close"
                    color="inherit"
                    className={() => this.setState({error:false})}
                    onClick={() => this.setState({error:false})}
                  >
                    <Close/>
                  </IconButton>,
                ]}
              />
            }
            <Button
              fullWidth
              variant="contained"
              className={classes.button}
              onClick={() => { this.login(); }}>
              Sign in
            </Button>
          </form>
        </Paper>
      </main>
    )
  }
}

Login.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {state:state}
}

const mapDispatchToProps = (dispatch) => {
  return {
    setUser: (userid,user) => dispatch({type: "SET_USER", payload: { userid: userid, user: user }})
  }

}

export default connect(mapStateToProps,mapDispatchToProps)(withStyles(styles)(Login));
